import validate from 'validate.js';
import moment from 'moment';
import { toSucataTimestamp } from './usoMutuoPeriodo';

export const TIPO_NSMP_SUCATA = {
  ENTREGA: 'ENTREGA_SUCATA',
  PESAGEM: 'PESAGEM_SUCATA',
};

const sumPesoItens = (itens) =>
  (itens || []).reduce((total, item) => total + (Number(item.pesoKg) || 0), 0);

export const mapNsmpToSucataFormValues = (nsmp) => {
  if (!nsmp) {
    return {
      fotos: [],
      observacao: '',
      periodoOptionId: '',
      sucata: {
        data: moment().startOf('day').valueOf(),
        periodoInicio: null,
        periodoFim: null,
        pesoTotalKg: null,
        itens: [],
      },
    };
  }

  const sucata = nsmp.sucata || {};

  return {
    ...nsmp,
    fotos: nsmp.fotos || [],
    observacao: nsmp.observacao || '',
    periodoOptionId: '',
    sucata: {
      ...sucata,
      data: toSucataTimestamp(sucata.data) || moment().startOf('day').valueOf(),
      periodoInicio: toSucataTimestamp(sucata.periodoInicio),
      periodoFim: toSucataTimestamp(sucata.periodoFim),
      pesoTotalKg: sucata.pesoTotalKg ?? null,
      itens: Array.isArray(sucata.itens) ? sucata.itens : [],
    },
  };
};

export const getEmptySucataFormValues = () => mapNsmpToSucataFormValues(null);

export const buildSucataPayload = ({
  values,
  tipoNsmp,
  updateFiles,
  periodoInicio,
  periodoFim,
}) => {
  const itens = tipoNsmp === TIPO_NSMP_SUCATA.PESAGEM
    ? (values.sucata?.itens || []).map((item) => ({
      id: item.id,
      tipo: item.tipo,
      tipoNome: item.tipoNome,
      pesoKg: Number(item.pesoKg),
      externalId: item.externalId,
    }))
    : null;

  const pesoTotalKg = tipoNsmp === TIPO_NSMP_SUCATA.PESAGEM
    ? sumPesoItens(itens)
    : Number(values.sucata?.pesoTotalKg);

  return {
    ...values,
    tipoNsmp,
    observacao: values.observacao || '',
    fotos: values.fotos || [],
    updateFiles,
    sucata: {
      ...(values.sucata || {}),
      data: toSucataTimestamp(values.sucata?.data),
      periodoInicio: toSucataTimestamp(periodoInicio),
      periodoFim: toSucataTimestamp(periodoFim),
      pesoTotalKg,
      itens,
      quantidadeItens: tipoNsmp === TIPO_NSMP_SUCATA.PESAGEM ? (itens || []).length : null,
    },
  };
};

export const validateEntregaSucata = (values) => {
  const errors = validate(values, {
    fotos: {
      presence: { allowEmpty: false, message: 'é obrigatório' },
    },
  }) || {};

  if (!values.sucata?.data) {
    errors['sucata.data'] = ['é obrigatório'];
  }
  if (!values.periodoOptionId) {
    errors.periodoOptionId = ['é obrigatório'];
  }
  if (!values.sucata?.pesoTotalKg || Number(values.sucata.pesoTotalKg) <= 0) {
    errors['sucata.pesoTotalKg'] = ['é obrigatório'];
  }

  return Object.keys(errors).length > 0 ? errors : null;
};

export const validatePesagemSucata = (values) => {
  const errors = validate(values, {
    fotos: {
      presence: { allowEmpty: false, message: 'é obrigatório' },
    },
  }) || {};

  if (!values.sucata?.data) {
    errors['sucata.data'] = ['é obrigatório'];
  }
  if (!values.periodoOptionId) {
    errors.periodoOptionId = ['é obrigatório'];
  }
  if (!Array.isArray(values.sucata?.itens) || values.sucata.itens.length === 0) {
    errors['sucata.itens'] = ['é obrigatório adicionar ao menos um material'];
  }

  return Object.keys(errors).length > 0 ? errors : null;
};

export const sumSucataItensPeso = sumPesoItens;
